import appInsightsService from './AppInsights';

const Logger = {
  error: (msg: string, ...args: unknown[]) => {
    const properties = argsToProperties(args);
    appInsightsService.trackException({
      exception: new Error(msg),
      severityLevel: 3,
      properties,
    });
    console.error(msg, ...args);
  },

  warn: (msg: string, ...args: unknown[]) => {
    const properties = argsToProperties(args);
    appInsightsService.trackTrace({
      message: msg,
      severityLevel: 2,
      properties,
    });
    console.warn(msg, ...args);
  },

  info: (msg: string, ...args: unknown[]) => {
    const properties = argsToProperties(args);
    appInsightsService.trackTrace({
      message: msg,
      severityLevel: 1,
      properties: properties,
    });
    console.info(msg, ...args);
  },

  debug: (msg: string, ...args: unknown[]) => {
    console.debug(msg, ...args);
  },
};

function argsToProperties(args: unknown[]): { [key: string]: string } {
  const properties: { [key: string]: string } = {};
  args.forEach((arg, index) => {
    properties[`arg${index}`] = stringifyArg(arg);
  });
  return properties;
}

function stringifyArg(arg: unknown): string {
  if (arg === null) return 'null';
  if (arg === undefined) return 'undefined';
  if (typeof arg === 'object') {
    try {
      return JSON.stringify(arg);
    } catch {
      return String(arg);
    }
  }
  return String(arg);
}

export default Logger;
